// List of articles that should not have the below header ad
const excludeBelowHeaderAdUrls = [
  '/bmw/ix1',
  '/volvo/ex30',
  '/mitsubishi/asx',
  '/vauxhall/grandland',
  '/kia/niro-ev',
  '/7-seater-cars/108107/top-10-best-7-seater-cars-buy',
  '/best-cars-vans/106657/best-small-cars-buy',
  '/hot-hatches/66682/top-10-best-hot-hatchbacks-buy',
  '/driver-power/64280/top-10-most-reliable-cars-buy',
  '/best-cars-vans/351901/top-10-cheapest-cars-buy',
  // New entries for the experiment
  '/audi/a3',
  '/land-rover/range-rover',
  '/fiat/500',
  '/audi/q3',
  '/ford/capri',
  '/ford/puma',
  '/mercedes/a-class',
  '/peugeot/3008',
  '/land-rover/range-rover-evoque',
  '/toyota/yaris',
  '/volkswagen/golf',
  '/volvo/xc40',
  '/audi/q5',
  '/bmw/4-series/m4-coupe',
  '/citroen/c3',
  '/ford/focus',
  '/ford/ranger',
  '/hyundai/i10',
  '/mercedes/gla',
  '/nissan/juke',
  '/skoda/kodiaq',
  '/vauxhall/mokka',
  '/bmw/3-series/m3-saloon',
  '/dacia/duster',
  '/ineos/grenadier',
  '/mazda/cx-5',
  '/porsche/macan',
  '/seat/ibiza',
  '/tesla/model-3',
  '/toyota/rav4',
  '/audi/a4',
  '/audi/q7',
  '/bmw/3-series',
  '/bmw/5-series/m5',
  '/bmw/x3',
  '/dacia/bigster',
  '/honda/cr-v',
  '/hyundai/kona',
  '/kia/ev3',
  '/kia/niro',
  '/peugeot/5008',
  '/renault/captur',
  '/skoda/fabia',
  '/volkswagen/t-roc',
  '/bmw/i4',
  '/citroen/c1',
  '/hyundai/i20',
  '/jeep/avenger',
  '/kia/ceed',
  '/kia/sorento',
  '/mazda/3',
  '/mercedes/cla',
  '/mg/zs',
  '/nissan/micra',
  '/peugeot/308',
  '/seat/arona',
  '/skoda/enyaq',
  '/skoda/octavia',
  '/toyota/supra',
  '/volkswagen/transporter',
  '/audi/a6',
  '/bentley/continental-gt',
  '/bmw/ix',
  '/citroen/c4',
  '/dacia/sandero',
  '/fiat/panda',
  '/hyundai/ioniq-5',
  '/kia/stonic',
  '/mercedes/gle',
  '/mitsubishi/outlander',
  '/land-rover/range-rover-velar',
  '/skoda/kamiq',
  '/toyota/yaris-cross',
  '/volkswagen/beetle',
  '/volkswagen/id-buzz',
  '/volkswagen/touareg',
  '/alfa-romeo/giulia',
  '/bentley/bentayga',
  '/bmw/x7',
  '/byd/dolphin',
  '/cupra/born',
  '/ford/ecosport',
  '/jaguar/xf',
  '/lexus/lbx',
  '/mazda/cx-30',
  '/mercedes/eqb',
  '/polestar/3',
  '/rolls-royce/cullinan',
  '/skoda/superb',
  '/toyota/prius',
  '/volkswagen/id4',
  '/volkswagen/taigo',
  '/bmw/i7',
  '/bmw/x4',
  '/byd/atto-3',
  '/ford/galaxy',
  '/honda/nsx',
  '/jaguar/i-pace',
  '/kia/rio',
  '/mercedes/s-class',
  '/omoda/5',
  '/subaru/impreza',
  '/toyota/auris',
  '/volkswagen/tayron',
  '/volkswagen/passat',
  '/audi/e-tron-gt',
  '/bmw/4-series',
  '/bmw/1-series/97406/new-bmw-m140i-review',
  '/byd/sealion-7',
  '/cupra/leon',
  '/fiat/600',
  '/hyundai/i30/n',
  '/jeep/compass',
  '/lexus/nx',
  '/lotus/emira',
  '/mercedes/sprinter',
  '/mg/mg4',
  '/nissan/navara',
  '/peugeot/108',
  '/renault/austral',
  '/renault/symbioz',
  '/suzuki/ignis',
  '/toyota/bz4x',
  '/toyota/gt-86',
  '/volkswagen/arteon',
  '/volkswagen/sharan',
  '/alfa-romeo/giulietta',
  '/audi/a8',
  '/audi/q6-e-tron',
  '/audi/s5',
  '/bmw/ix2',
  '/ford/edge',
  '/ford/mustang-mach-e',
  '/hyundai/bayon',
  '/jaecoo/7',
  '/kia/soul',
  '/lotus/elise',
  '/mercedes/amg-gt',
  '/mini/clubman',
  '/polestar/4',
  '/toyota/c-hr',
  '/volvo/xc60',
  '/hyundai/kona/electric',
  '/byd/seal-u',
  '/volkswagen/id5',
  '/mg/zs/ev',
  '/mercedes/eqc',
  '/mg/mg5',
];

export default excludeBelowHeaderAdUrls;
